// utils/exportTableExcell.js

const buildTableHtml = (tableId, title, options = {}) => {
  const tableElement = document.getElementById(tableId);
  if (!tableElement) return null;

  const {
    removeSelectors = ['button', '.action-btn', 'input', 'img', '.expand-toggle-btn'],
    stripedEvenColor = '#ffffff',
    stripedOddColor = '#f8f9fa',
    theadColor = '#cfe2ff',
  } = options;

  // Знімаємо стилі badge ДО клонування через data-атрибути
  tableElement.querySelectorAll('.badge').forEach(badge => {
    const computed = window.getComputedStyle(badge);
    badge.dataset.exportBg = computed.backgroundColor;
    badge.dataset.exportColor = computed.color;
    badge.dataset.exportFontSize = computed.fontSize;
    badge.dataset.exportFontWeight = computed.fontWeight;
  });

  // Знімаємо стилі клітинок ДО клонування через data-атрибути
  tableElement.querySelectorAll('th, td').forEach(cell => {
    const computed = window.getComputedStyle(cell);
    const bg = computed.backgroundColor;
    cell.dataset.exportFontWeight = computed.fontWeight;
    cell.dataset.exportTextAlign = computed.textAlign;
    cell.dataset.exportColor = computed.color;
    cell.dataset.exportFontSize = computed.fontSize;
    cell.dataset.exportBg = (bg && bg !== 'rgba(0, 0, 0, 0)' && bg !== 'transparent') ? bg : '';
  });

  // Клонуємо — data-атрибути копіюються автоматично
  const tableClone = tableElement.cloneNode(true);

  // Прибираємо data-атрибути з оригіналу
  tableElement.querySelectorAll('.badge, th, td').forEach(el => {
    Object.keys(el.dataset)
      .filter(k => k.startsWith('export'))
      .forEach(k => delete el.dataset[k]);
  });

  // Видаляємо інтерактивні елементи з клону (БЕЗ .badge!)
  tableClone.querySelectorAll(removeSelectors.join(', ')).forEach(el => el.remove());

  // Замінюємо badge — колір фону переносимо на батьківський td
  tableClone.querySelectorAll('.badge').forEach(el => {
    const bg = el.dataset.exportBg;
    const color = el.dataset.exportColor;

    const span = document.createElement('span');
    span.textContent = el.textContent;
    span.style.color = color;
    span.style.fontWeight = el.dataset.exportFontWeight;

    // Колір на батьківський td — Excel бачить td а не span всередині
    const parentTd = el.closest('td');
    if (parentTd) {
      parentTd.style.backgroundColor = bg;
      parentTd.style.color = color;
      parentTd.style.textAlign = 'center';
      // Маркуємо td щоб не перезаписати колір при чергуванні рядків
      parentTd.dataset.hasBadgeBg = 'true';
    }

    el.parentNode.replaceChild(span, el);
  });

  // Застосовуємо стилі до клітинок клону з data-атрибутів
  tableClone.querySelectorAll('th, td').forEach(clonedCell => {
    clonedCell.style.fontWeight = clonedCell.dataset.exportFontWeight || '';
    clonedCell.style.textAlign = clonedCell.style.textAlign || clonedCell.dataset.exportTextAlign || '';
    clonedCell.style.color = clonedCell.style.color || clonedCell.dataset.exportColor || '';
    clonedCell.style.fontSize = clonedCell.dataset.exportFontSize || '';
    clonedCell.style.fontFamily = 'Arial, sans-serif';
    clonedCell.style.padding = '6px 10px';
    clonedCell.style.border = '1px solid #ccc';
    clonedCell.style.whiteSpace = 'nowrap';

    // Не перезаписуємо колір якщо вже встановлено від badge
    if (!clonedCell.dataset.hasBadgeBg && clonedCell.dataset.exportBg) {
      clonedCell.style.backgroundColor = clonedCell.dataset.exportBg;
    }

    // Прибираємо data-атрибути з результату
    Object.keys(clonedCell.dataset)
      .filter(k => k.startsWith('export') || k === 'hasBadgeBg')
      .forEach(k => delete clonedCell.dataset[k]);
  });

  // Явне чергування рядків tbody — не чіпаємо td з badge
  const tbodyRows = tableClone.querySelectorAll('tbody tr');
  tbodyRows.forEach((row, index) => {
    row.querySelectorAll('td').forEach(td => {
      if (td.dataset.hasBadgeBg) return;
      const currentBg = td.style.backgroundColor;
      if (!currentBg || currentBg === 'rgba(0, 0, 0, 0)' || currentBg === 'transparent') {
        td.style.backgroundColor = index % 2 === 0 ? stripedEvenColor : stripedOddColor;
      }
    });
  });

  // thead fallback
  tableClone.querySelectorAll('thead th').forEach(th => {
    const bg = th.style.backgroundColor;
    if (!bg || bg === 'rgba(0, 0, 0, 0)' || bg === 'transparent') {
      th.style.backgroundColor = theadColor;
      th.style.fontWeight = 'bold';
    }
  });

  // Кількість колонок для автофільтра
  const colCount = tableClone.querySelectorAll('thead th').length;

  return `
    <html xmlns:o="urn:schemas-microsoft-com:office:office"
          xmlns:x="urn:schemas-microsoft-com:office:excel"
          xmlns="http://www.w3.org/TR/REC-html40">
      <head>
        <meta charset="UTF-8">
        <xml>
          <x:ExcelWorkbook>
            <x:ExcelWorksheets>
              <x:ExcelWorksheet>
                <x:Name>Дані</x:Name>
                <x:WorksheetOptions>
                  <x:Selected/>
                  <x:FreezePanes/>
                  <x:FrozenNoSplit/>
                  <x:SplitHorizontal>2</x:SplitHorizontal>
                  <x:TopRowBottomPane>2</x:TopRowBottomPane>
                </x:WorksheetOptions>
                <x:AutoFilter x:Range="R2C1:R2C${colCount}"/>
              </x:ExcelWorksheet>
            </x:ExcelWorksheets>
          </x:ExcelWorkbook>
        </xml>
        <style>table { border-collapse: collapse; }</style>
      </head>
      <body>
        <h3 style="font-family:Arial,sans-serif;font-size:14px;">${title}</h3>
        ${tableClone.outerHTML}
      </body>
    </html>
  `;
};

/**
 * Копіює таблицю в буфер обміну (Ctrl+V в Excel)
 * @param {string} tableId - id таблиці
 * @param {string} title - заголовок
 * @param {Object} options - опції
 * @param {string[]} options.removeSelectors - селектори елементів для видалення
 * @param {string} options.stripedEvenColor - колір парних рядків tbody
 * @param {string} options.stripedOddColor - колір непарних рядків tbody
 * @param {string} options.theadColor - колір фону thead
 */
export const copyTableToClipboard = async (tableId, title, options = {}) => {
  const html = buildTableHtml(tableId, title, options);
  if (!html) {
    alert('Таблицю не знайдено');
    return;
  }
  try {
    await navigator.clipboard.write([
      new ClipboardItem({ 'text/html': new Blob([html], { type: 'text/html' }) })
    ]);
    alert('Скопійовано! Вставте в Excel через Ctrl+V');
  } catch (err) {
    console.error('Clipboard error:', err);
    alert('Помилка копіювання. Спробуйте "Завантажити .xls"');
  }
};

/**
 * Завантажує таблицю як .xls файл з автофільтром і закріпленим заголовком
 * @param {string} tableId - id таблиці
 * @param {string} title - заголовок
 * @param {string} filename - ім'я файлу без розширення
 * @param {Object} options - опції
 */
export const downloadTableXls = (tableId, title, filename, options = {}) => {
  const html = buildTableHtml(tableId, title, options);
  if (!html) {
    alert('Таблицю не знайдено');
    return;
  }
  const blob = new Blob([html], { type: 'application/vnd.ms-excel;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${filename}.xls`;
  a.click();
  URL.revokeObjectURL(url);
};